/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type ListNamespaceRelationshipsInput = {
    /**
     * Optional starting namespace id or name. When provided, relationships are scoped relative to this namespace.
     */
    namespace_id?: (string | null);
    /**
     * Which side of the namespace graph to traverse from `namespace_id`.
     */
    direction?: ListNamespaceRelationshipsInput.direction;
    /**
     * When true, includes transitive parent/child namespaces reachable from `namespace_id`.
     */
    include_indirect?: boolean;
};

export namespace ListNamespaceRelationshipsInput {

    /**
     * Which side of the namespace graph to traverse from `namespace_id`.
     */
    export enum direction {
        PARENTS = 'parents',
        CHILDREN = 'children',
        BOTH = 'both',
    }


}

